import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import WhyChooseImg from '../assets/WhyChoose.svg';
import './WhyChooseSection.css';

const WhyChooseSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const items = [
    {
      title: '100% Canadian-Owned',
      content: 'Your rides support local communities. Unlike foreign-owned platforms, KabX keeps profits in Canada, creating jobs and economic opportunities right here at home.'
    },
    {
      title: "Women's Empowerment",
      content: "Empowering women drivers with flexible income opportunities while creating a safer ride experience. Join 200+ women already driving with KabX."
    },
    {
      title: 'Enhanced Safety',
      content: 'Your safety is our priority with comprehensive background checks, GPS tracking, emergency buttons, real-time ride sharing with family, and 24/7 support.'
    },
    {
      title: 'Community-Focused',
      content: 'Built by Canadian for Canadian. We understand local needs and build lasting partnerships with businesses and community organizations.'
    },
    {
      title: 'Eco-Friendly Options',
      content: 'Reduced commission rates for electric and hybrid vehicles. Smart ride-sharing reduces carbon emissions and traffic congestion.'
    }
  ];

  return (
    <section id="why-KabX" className="why-choose-section">
      <div className="section-container">
        {/* <div className="section-header">
          <h2 className="section-title">Why Choose KabX?</h2>
        </div> */}

        <div className="why-choose-grid">
          {/* Accordion Section */}
          <div className="accordion-wrapper">
            {/* <h2 className="section-title">Why Choose KabX?</h2> */}
            <h2 className="section-title">
              Why Choose
              <span className="highlight-word">KabX?</span>
            </h2>
            {items.map((item, index) => (
              <div key={index} className={`accordion-item ${activeIndex === index ? 'active' : ''}`}>
                <button
                  className="accordion-trigger"
                  onClick={() => setActiveIndex(activeIndex === index ? -1 : index)}
                >
                  {/* <span className="accordion-item-icon">{item.icon}</span> */}
                  <span className="accordion-title">{item.title}</span>

                  {/* Toggle Icon */}
                  {activeIndex === index ? (
                    <ChevronUp size={20} />
                  ) : (
                    <ChevronDown size={20} />
                  )}
                </button>

                {activeIndex === index && (
                  <div className="accordion-content">
                    <p>{item.content}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Right Side Image */}
          <div className="why-choose-visual">
            <img
              src={WhyChooseImg}
              alt="Why Choose KabX"
              className="why-choose-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
